// extracted by mini-css-extract-plugin
export default {"inputsBlock":"CalendarInputs_inputsBlock__PNK9H","active":"CalendarInputs_active__qEJcT"};